"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { UnifiedModernHero } from "./UnifiedModernHero";
interface HeroData {
  heading?: string;
  subheading?: string;
  formHeading?: string;
  licensePlaceholder?: string;
  statePlaceholder?: string;
  vinPlaceholder?: string;
  btnText?: string;
  trustBadges?: Array<{
    text: string;
    icon?: string;
  }>;
}
interface UnifiedSellMyCarFlowProps {
  heroData: HeroData;
  backgroundImage: string;
  states: Array<{
    label: string;
    value: string;
  }>;
}
export function UnifiedSellMyCarFlow(t0) {
  const $ = _c(4);
  const {
    heroData,
    backgroundImage,
    states
  } = t0;
  let t1;
  if ($[0] !== backgroundImage || $[1] !== heroData || $[2] !== states) {
    t1 = <UnifiedModernHero heroData={heroData} states={states} backgroundImage={backgroundImage} />;
    $[0] = backgroundImage;
    $[1] = heroData;
    $[2] = states;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}